<div class="grid" style="margin-top: 8px;">
  <div class="col-12 lg:col-6">
    <div class="card main-height">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.defaultDeviceInfo' | transloco}}</h4></div>
      <hr>
      <table class="details-table striped-table" *ngIf="defaultDeviceCatalog">
        <tr>
          <td class="p-3 bold">{{'attribute.uuid' | transloco}}</td>
          <td class="pr-1"><app-clipboard-label [value]="defaultDeviceCatalog.uuid" [copiedValue]="defaultDeviceCatalog.uuid"></app-clipboard-label></td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.version' | transloco}}</td>
          <td>{{defaultDeviceCatalog.version}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.description' | transloco}}</td>
          <td *ngIf="defaultDeviceCatalog.description">{{defaultDeviceCatalog.description}}</td>
          <td *ngIf="!defaultDeviceCatalog.description" class="font-italic">{{'empty.description' | transloco}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.active' | transloco}}</td>
          <td *ngIf="defaultDeviceCatalog.active">{{'common.active' | transloco}}</td>
          <td *ngIf="!defaultDeviceCatalog.active">{{'common.inactive' | transloco}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.category' | transloco}}</td>
          <td>{{defaultDeviceCatalog.defaultDeviceCategory.name}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.assetRepresentation' | transloco}}</td>
          <td>{{defaultDeviceCatalog.defaultAssetRepresentation.name}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.createdAt' | transloco}}</td>
          <td>{{defaultDeviceCatalog.creationDate | customDate}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.updatedAt' | transloco}}</td>
          <td>{{defaultDeviceCatalog.updatedDate | customDate}}</td>
        </tr>
      </table>
      <app-table-skeleton *ngIf="!defaultDeviceCatalog" class="w-full" [rows]="6" height="200px" [striped]="true"></app-table-skeleton>
    </div>
  </div>
</div>
